import { Injectable } from '@angular/core';
import { WP_REST_API_Attachment} from 'wp-types';
import {WP_REST_API_Endpoints} from "../enums/wp-rest-api-endpoints";
import {ApiService} from "./api.service";
import {environment} from "../../environments/environment";
import {PageExtended} from "../models/Page/PageExtended";
import {WP_REST_API_Menu_item} from "../models/Wordpress/WP_REST_API_Menu_item";
import {WP_REST_API_Language} from "../models/Wordpress/WP_REST_API_Language";
import {WP_REST_API_Breadcrumb_item} from "../models/Wordpress/WP_REST_API_Breadcrumb_item";
import {SocialNetworks} from "../models/Misc/SocialNetworks";
import {HttpHeaders, HttpParamsOptions, HttpTransferCacheOptions} from "@angular/common/http";
import {Meteo} from "../models/Misc/Meteo";
import {NewsletterData} from "../models/Misc/NewsletterData";
@Injectable({
  providedIn: 'root'
})
export class WordpressService {

  constructor(public api : ApiService) {

  }
  getUrl(endpoint:string){
    return `${environment.wpApiUrl}${endpoint}`;
  }

  getVisitVarEndpoint(method:string){
    return `${environment.wpApiUrl}/vv/${method}`;
  }


  getPolylangEndpoint(method:string){
    return `${environment.wpApiUrl}/pll/v1/${method}`;
  }

  async getPageBySlug(slug: string, link: string): Promise<PageExtended> {
    return new Promise(async (resolve,reject)=>{
      let posts = await this.api.get<PageExtended[]>(this.getUrl(WP_REST_API_Endpoints.PAGES),{slug});
      if(posts && posts.length>0){
        posts = posts.filter((p)=>p.link === link);
        if(posts && posts.length>0){
          const post = posts[0];
          if(post.link === link){
            resolve(post);
          } else{
            reject();
          }
        } else {
          reject();
        }
      } else {
        reject();
      }
    });
  }

  async getAttachment(id: number): Promise<WP_REST_API_Attachment|null> {
    const attachment = await this.api.get<WP_REST_API_Attachment>(`${this.getUrl(WP_REST_API_Endpoints.ATTACHMENTS)}${id}`,);
    return attachment;
  }

  async getBreadcrumbs(id: number): Promise<WP_REST_API_Breadcrumb_item[]> {
    const breadcrumbs = await this.api.get<any>(`${this.getVisitVarEndpoint('breadcrumbs')}`,{post_id:id});
    return breadcrumbs['breadcrumbs'] ?? [];
  }

  async getFrontpage(): Promise<PageExtended|null> {
    const post = await this.api.get<PageExtended>(this.getVisitVarEndpoint('frontpage'));
    return post;
  }

  async getMenuItems(location: string): Promise<WP_REST_API_Menu_item[]|null> {
    return await this.api.get<WP_REST_API_Menu_item[]>(`${this.getVisitVarEndpoint('menus')}/${location}`);
  }

  async getLanguages(type:'home'|'page'|'fiche', id?:string|number, slug?:string){
    return await this.api.get<WP_REST_API_Language[]>(`${this.getVisitVarEndpoint('languages')}`,{id:id,type:type, slug:slug});
  }

  async getSocialNetworks(){
    return await this.api.get<SocialNetworks>(`${this.getVisitVarEndpoint('social-networks')}`);
  }

  async getPartners(){
    return await this.api.get<{partners: any[],others_partners: any[],others_partners_carroussel: any[]}>(`${this.getVisitVarEndpoint('partners')}`);
  }

  async getSearchData(){
    return await this.api.get<{keywords: string,featured_pages: number[]}>(`${this.getVisitVarEndpoint('search')}`);
  }

  async getThemeColors(){
    return await this.api.get<string>(`${this.getVisitVarEndpoint('theme-colors')}`,null);
  }

  async getMeteo(){
    return await this.api.get<Meteo>(`${this.getVisitVarEndpoint('meteo')}`,null);
  }

  async getReviews(id:number|string){
    return await this.api.get<any>(`${this.getVisitVarEndpoint('reviews')}`, {id});
  }

  async getNewsletterData(){
    return await this.api.get<NewsletterData>(`${this.getVisitVarEndpoint('newsletter')}`);
  }

  async getSynapiPdf(withCovers:boolean=false,ids:string[],withIti:boolean=false) :Promise<string>{
    return await this.api.get<string>(`${this.getVisitVarEndpoint('synapi/pdf/')}`, {withCovers,ids, withIti});
  }


  async getTinyPosts(ids : number[], orderby: string = "menu_order") {
    return new Promise<PageExtended[]>((resolve,reject)=>{
      const promises = [];
      const per_page = 100;
      const pages = Math.ceil(ids.length/per_page);
      for(let i=0; i<pages; i++ ){
        const idsSliced = ids.slice(i*per_page,i*per_page+per_page);
        promises.push(this.api.get<PageExtended[]>(this.getUrl(WP_REST_API_Endpoints.PAGES),{include:idsSliced.join(','),per_page:per_page, _fields: "id,link,title,featured_media,featured_media_object,page_categories", orderby:orderby, order: "asc"}))
      }
      Promise.all(promises).then((data)=>{
        let posts:PageExtended[] = [];
        data.forEach((p)=>{
          posts = posts.concat(p);
        });
        posts = posts.filter((post,index,self) =>
          index === self.findIndex((t) => (
            t.id === post.id
          ))
        )
        resolve(posts);
      });
    })

  }
}
